
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as thank_45youLGIvVY96dUO5HJ5quOn8XcxSKBlp0oz5BgX2wn7Hm6kMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/contact/thank-you.vue?macro=true";
import { default as product_45page_45demo2x6k3xrqVPOjlii0yBvwEiIsWf5rZHOTtA_wAqDUG3AMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/demo/product-page-demo.vue?macro=true";
import { default as case_45study_45card3k0FR9ddfvhMGbxxERR__HUi8tdxJd2V_StUsSmtZnQMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/test/case-study-card.vue?macro=true";
import { default as _91slug_93QU_3qtEbzNdPh6N3cXNDHmcPTvkt_uvFHV0IOpHJuSUMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/blog/[slug].vue?macro=true";
import { default as _404Rbt2kjCK4_b4LP_LYZFC5NodLrUbCQMz1veKTquljEQMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/404.vue?macro=true";
import { default as aboutuGuxB2ELkvihcy6Vp6Gan4H1gjHfjJqzvT6rkeIRp14Meta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/about.vue?macro=true";
import { default as indexoriRicqs_Hfz9Tt9IWqtF_Tv4ujzx2ZsaB4SSyudDWMMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/blog/index.vue?macro=true";
import { default as indexdR4R9XRetMSYwj76gCWmUuALsABkc0TubLP7jBLWlGgMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/contact/index.vue?macro=true";
import { default as cookiesNO47WKwbuRbDJ4GYqR_eUme5kKJa1hZGIAlfAakoAbgMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/cookies.vue?macro=true";
import { default as insight_PBCENeNFIeJEIHyulBBsYNoKtWbDp5YzvyiFcB7pcoMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/insight.vue?macro=true";
import { default as privacyvCS_G2yHAG38QKuA_hiPAo_HSE4TFDpqM9rAnTY4L4cMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/privacy.vue?macro=true";
import { default as productI6lE9N2FUAItQkCNf4LdVRgqCTVUYGlGlf2b4GRo5XIMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/product.vue?macro=true";
import { default as product_45template_45testuWBJbQyjVhwseidrrH_17U4CUjZQX_4uuH3MGf3OS9YMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/product-template-test.vue?macro=true";
import { default as reviewo_Pqq38SCfa5P3gQx_lHif_J7x8m0wJVlvWBjCOJ_H8Meta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/review.vue?macro=true";
import { default as review_45get_45startedT4beIrobvQ9qavcBNQmGXNN1RYdVvyXH5xZY3stBrCUMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/review-get-started.vue?macro=true";
import { default as review_45register_45interest2xXQctkFF_K1vxCF_kuu_btRDtj5tt_xQyivtJIp2BgMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/review-register-interest.vue?macro=true";
import { default as spike_45112_45141_45T000_45AmIi28Q5M_kNtJnNnFDtIzdlC7bPttVFh72pgGXMikgUMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/spike-112-141-T000-A.vue?macro=true";
import { default as termsD2wjjDpWhExxHS5LYYYho74oJCmYoUYFiP0q9WqvCe8Meta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/terms.vue?macro=true";
import { default as test_45ucardrTM7COVEaOldzETA3cvm_s2Yg1hlIxG8AimuzjfU3gMMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/test-ucard.vue?macro=true";
import { default as test_45wcag_45spike9u_X1XV6mzOvNSE_X4jfsQp3X3p0tbwjhVPxv63LbHUMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/test-wcag-spike.vue?macro=true";
import { default as verify_AR_xP74BSoe_4dF_fvq0yiyhZCpAc6dt3qXwMVa_OoMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/verify.vue?macro=true";
import { default as _91_46_46_46slug_93EX_kfOatl2V24uH62XhT0IwsKjqa4Acy_yMGn9QsKAUMeta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/[...slug].vue?macro=true";
import { default as index4LtXoUDkVqmz4C21PP424OP5iWwXtbIbRESXZ1MvXX8Meta } from "/home/runner/work/qx-solarheart/qx-solarheart/app/pages/index.vue?macro=true";
export default [
  {
    name: "contact-thank-you",
    path: "/contact/thank-you",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/contact/thank-you.vue")
  },
  {
    name: "demo-product-page-demo",
    path: "/demo/product-page-demo",
    meta: product_45page_45demo2x6k3xrqVPOjlii0yBvwEiIsWf5rZHOTtA_wAqDUG3AMeta || {},
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/demo/product-page-demo.vue")
  },
  {
    name: "test-case-study-card",
    path: "/test/case-study-card",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/test/case-study-card.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/blog/[slug].vue")
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/404.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/about.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexoriRicqs_Hfz9Tt9IWqtF_Tv4ujzx2ZsaB4SSyudDWMMeta || {},
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/blog/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/contact/index.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/cookies.vue")
  },
  {
    name: "insight",
    path: "/insight",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/insight.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/privacy.vue")
  },
  {
    name: "product",
    path: "/product",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/product.vue")
  },
  {
    name: "product-template-test",
    path: "/product-template-test",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/product-template-test.vue")
  },
  {
    name: "review",
    path: "/QxReview",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/review.vue")
  },
  {
    name: "review-get-started",
    path: "/review-get-started",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/review-get-started.vue")
  },
  {
    name: "review-register-interest",
    path: "/review-register-interest",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/review-register-interest.vue")
  },
  {
    name: "spike-112-141-T000-A",
    path: "/spike-112-141-T000-A",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/spike-112-141-T000-A.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/terms.vue")
  },
  {
    name: "test-ucard",
    path: "/test-ucard",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/test-ucard.vue")
  },
  {
    name: "test-wcag-spike",
    path: "/test-wcag-spike",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/test-wcag-spike.vue")
  },
  {
    name: "verify",
    path: "/verify",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/verify.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/[...slug].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/qx-solarheart/qx-solarheart/app/pages/index.vue")
  }
]